import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import type WeeklyRecurrence from 'owa-service/lib/contract/WeeklyRecurrence';
import {
    DAILY_RECURRENCE_TYPE_NAME,
    DAYS_OF_WEEK,
    WEEKLY_RECURRENCE_TYPE_NAME,
} from 'owa-recurrence-types';

export default function getSelectedDaysFromRecurrence(recurrence: RecurrenceType): string[] {
    let selectedDays = [];

    if (recurrence != null && recurrence.RecurrencePattern != null) {
        switch (recurrence.RecurrencePattern.__type) {
            case DAILY_RECURRENCE_TYPE_NAME: {
                DAYS_OF_WEEK.map(day => {
                    selectedDays.push(day);
                });
                break;
            }
            case WEEKLY_RECURRENCE_TYPE_NAME: {
                let weeklyRecurrence = recurrence.RecurrencePattern as WeeklyRecurrence;
                selectedDays = weeklyRecurrence.DaysOfWeek.split(' ');
                break;
            }
        }
    }

    return selectedDays;
}
